<template>
  <div class="main-sidebar sidebar-style-2" tabindex="1">
    <aside id="sidebar-wrapper">
      <div class="sidebar-brand">
        <router-link :to="{name: 'Inbox'}">
          <img :src="$helper.getFile('9f89c84a559f573636a47ff8daed0d33')" alt="logo" width="160"  />
        </router-link>
      </div>
      <div class="sidebar-brand sidebar-brand-sm">
        <router-link :to="{name: 'Inbox'}">
          <img :src="$helper.getFile('c96589eefb0828c07179095bcd0cef5f')" alt="logo" width="55" />
        </router-link>
      </div>

      <!-- card-search(filter) -->
      <div class="card" id="searchSideBar">
        <div class="card-header">
          <h4></h4>
          <form class="card-header-form" @submit.prevent>
            <div class="input-group">
              <input
                type="text"
                name="search"
                v-model="searchInput"
                class="form-control"
                :placeholder="$helper.getWord('Search')"
              />
              <div class="input-group-btn">
                <button class="btn btn-primary btn-icon" @click="search()">
                  <i class="fas fa-search"></i>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <!-- card-search(filter) -->
      <div style="display:block; text-align: right;" v-if="!getIsShowFormBuilderMenu && isFormBuilder">
        <button @click="$helper.setFormBuilderMenu(true)" class="btn btn-success navbar-btn" >
          {{$helper.getWord('Open FormBuilderMenu')}} <i class="fas fa-chevron-right"></i>
        </button>
      </div>
      <div class="sidebar-menu" v-if="getIsShowFormBuilderMenu">
        <FbSideBar class="fbsidebar"/>
      </div>

      <ul class="sidebar-menu" v-if="!getIsShowFormBuilderMenu">
        <!-- Transaction-->
        <template v-for="(routesList,key,index) in groupRoutes">
          <template v-for="(routes,key,ri) in routesList">
            <li class="menu-header" v-if="ri==0&&!routes[0].meta.excludeSideBar">{{key}}</li>
            <!-- multiple has dropdown -->
            <template v-if="routes[0].meta.sideBar.detail&&!routes[0].meta.excludeSideBar">
              <li class="dropdown">
                <a href="#" class="nav-link has-dropdown">
                  <i :class="routes[0].meta.sideBar.icon"></i>
                  <span class="link-span">{{key}}</span>
                </a>
                <ul class="dropdown-menu">
                  <template v-for="route in routes">
                    <router-link v-if="!route.meta.hidden" :to="{name: route.name }" tag="li">
                      <a
                        class="nav-link"
                        data-toggle="tooltip"
                        :data-original-title="route.meta.title"
                        data-placement="right"
                      >
                        <span class="link-span">{{route.meta.title}}</span>
                      </a>
                    </router-link>
                  </template>
                </ul>
              </li>
            </template>
            <!-- single not dropdown -->
            <template v-else>
              <template v-for="route in routes">
                <router-link :to="{name: route.name}" tag="li" v-if="!route.meta.excludeSideBar">
                  <a href="#" class="nav-link">
                    <i :class="route.meta.sideBar.icon"></i>
                    <span class="link-span">{{route.meta.title}}</span>
                  </a>
                </router-link>
              </template>
            </template>
          </template>
        </template>
      </ul>

      <div class="p-3 hide-sidebar-mini">
        <a :href="`${publicPath}static/template/Lswork_Documentation.docx`" class="btn btn-primary btn-lg btn-block btn-icon-split" download>
          <i class="fas fa-rocket"></i> {{$helper.getWord('Documentation')}}
        </a>
      </div>
       <div class="p-3 hide-sidebar-mini" v-if="autoGenerateForm">
        <button class="btn btn-primary btn-lg btn-block btn-icon-split" @click="generateExampleForm()">
          <i class="fas fa-table"></i> {{$helper.getWord('Generate Example Form')}}
        </button>
      </div>
      
    </aside>
  </div>
</template>

<script>
// import { bus } from "@/main";
import api from "@/api";
import config from "@/config";
import helper from "@/vueHelper";
import FbSideBar from "@/components/fbSideBar";
import { mapGetters } from "vuex";

export default {
  name: "sidebar",
  props: { stisla: Object },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      groupRoutes: {},
      searchInput: "",
      autoGenerateForm:false,
      config: config,
      user: JSON.parse(window.localStorage.getItem("ccrs_user")),
      $currentFormEditor: null,
      currenteditor: null,
      currentModel: null,
      modelBuilder: null
    };
  },
  created() {
    this.groupRoutes = Object.assign({}, this.computedRoutes);
  },
  components: {
    FbSideBar
  },
  watch: {
    getIsShowFormBuilderMenu(val) {
      if (val) {
        this.$nextTick(() => {
          this.stisla.sidebar_dropdown();
          $(".dropdown").removeClass("active");
          $(".dropdown-menu").css("display", "none");
          this.stisla.toolTip();
          this.stisla.update_sidebar_nicescroll();
        });
      } else {
        this.$nextTick(() => {
          this.stisla.sidebar_dropdown();
          this.stisla.toolTip();
          this.stisla.update_sidebar_nicescroll();
        });
      }
    }
  },
  methods: {

  generateExampleForm(){
      helper.loading();
      api.request(
        this,
        "post",
        `/userBuildForm/generateExampleForm`,
        {
          SessionID: helper.getSessionID(),
          LocaleCode: helper.getLocaleCode(),
         
        },
        function(r) {
           helper.done();
        
          },
        function(r) {
          helper.done();
        }
      );
  },

    getFileName(routeName) {
      let split = routeName.split("/");
      if (Array.isArray(split)) {
        return split[split.length - 1];
      }

      return routeName;
    },
    search() {
      if (this.searchInput == "") {
        this.groupRoutes = Object.assign({}, this.computedRoutes);
        this.$nextTick(() => {
          this.stisla.sidebar_dropdown();
          $(".dropdown").removeClass("active");
          $(".dropdown-menu").css("display", "none");
          this.stisla.toolTip();
          this.stisla.update_sidebar_nicescroll();
        });
      } else {
        let routes = this.vueroutes.filter(route => {
          //detail group name = POS Transaction ...
          if (route.meta.sideBar && route.meta.sideBar.detail) {
            return (
              route.meta.sideBar.detail.group
                .toUpperCase()
                .includes(this.searchInput.toUpperCase()) ||
              route.meta.title
                .toUpperCase()
                .includes(this.searchInput.toUpperCase())
            );
          } else {
            return route.meta.title
              .toUpperCase()
              .includes(this.searchInput.toUpperCase());
          }
        });
        this.groupRoutes = Object.assign({}, this.groupRoutesFunc(routes));
        this.$nextTick(() => {
          $(".dropdown").addClass("active");
          this.stisla.sidebar_dropdown();
          this.stisla.toolTip();
          this.stisla.update_sidebar_nicescroll();
        });
      }
    },
    groupRoutesFunc(routes) {
      let resultObject = {};
      routes.forEach(function(item, index, array) {
        if (item.meta.sideBar) {
          let group1Key, group2Key;
          group1Key = item.meta.sideBar.group;
          if (item.meta.sideBar.detail) {
            group2Key = item.meta.sideBar.detail.group;
          } else {
            group2Key = group1Key;
          }
          //init
          if (resultObject.hasOwnProperty(group1Key) == false) {
            resultObject[group1Key] = {};
            if (resultObject[group1Key].hasOwnProperty(group2Key) == false) {
              resultObject[group1Key][group2Key] = [];
            }
          }
          //if has value then push else init
          if (resultObject[group1Key][group2Key]) {
            resultObject[group1Key][group2Key].push(item);
          } else {
            resultObject[group1Key][group2Key] = [item];
          }
        }
      });
      return resultObject;
    }
  },
  computed: {
    ...mapGetters(["getIsShowFormBuilderMenu"]),
    vueroutes() {
      let router = this.$router.options.routes
        .find(item => item.name == "home")
        .children.slice();
      let roles = this.user?this.user.roles.slice():[];

      let roleRouter = router.filter(r => {

       

        if (!r.meta.access_code) {
          return null;
        }

        if (helper.hasAccess(r.meta.access_code)) {
          if(r.meta.access_code=='UBF_LIST01'){
            this.autoGenerateForm=true;
        }
          return r;
        }
        // return r
        return null;
      });

      return roleRouter;
    },
    computedRoutes() {
      return this.groupRoutesFunc(this.vueroutes);
    },
    isFormBuilder(){
      var ID = this.$route.query.ID;
      if(ID){
        return true;
      }else{
        return false;
      }
    }
  },

  mount() {}
};
</script>

